import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { formatCurrency, intFormat } from "./../../../js/shared/utils";
import SimulatorMiles from "../components/create-offer/template/SimulatorMiles";
import LoginOffer from "../components/create-offer/template/LoginOffer";
import StepBarIndicator from "../components/shared/StepBarIndicator";
import RegisterBankDetails from "../components/create-offer/template/RegisterBankDetails";
import RegisterCreditCard from "../components/create-offer/template/RegisterCreditCard";
import FinishedOffer from "../components/create-offer/template/FinishedOffer";
import { redirectToLogin } from "./../../../js/shared/utils";
import { logoutUser, getFidelities, hasBank, getBanks } from "./../../js/shared/requests-api";
import {
	getUserToken,
	isRelationshipStatusPendentOrNegotiation,
	isRelationshipStatusActive,
	getCorrectUrlByAcronym
} from "../shared/utils";
import Loading from "../../shared/Loading/Loading";
import Modal from "../../shared/Modal/Modal";
import { refreshOffers, receiveBanks, showOffers, editOffer } from "../actions";
import {
	ROUTE_PREFIX_EDIT_OFFER,
	ROUTE_HOME,
	ROUTE_REDIRECT_OFFER,
	ROUTE_REDIRECT_SIMULATOR
} from "../shared/constants";
import RegisterBankDetailsAndLogin from "../components/create-offer/template/RegisterBankDetailsAndLogin";
import { getRelationshipsParticipant } from "../actions/account-link";

let waitRequests = 0;

class CreateOffer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentStep: 1,
			fetchingOffers: false,
			hasManagementActive: false,
			hasRelationshipPendent: false,
			form: {
				errors: {}
			}
		};
		this._initialState = this.state;

		// Recupera dados se estava deslogado e foi redirecionado
		let fieldStorage = localStorage.getItem("CreateOffer");
		if (fieldStorage) {
			this.state.form = JSON.parse(fieldStorage);
			if (this.state.form.quickSale && !this.state.form.price) {
				this.state.form.quickSale = false;
			}
			if (this.state.form.forwardPayment && !this.state.form.price) {
				this.state.form.forwardPayment = false;
			}
			this.state.currentStep = this.state.form.currentStep || 1;
			this.searchOffer = true;
			localStorage.removeItem("CreateOffer");
		}

		this.incStep = this.incStep.bind(this);
		this.decStep = this.decStep.bind(this);
		this.edit = this.edit.bind(this);
		this.cleanValues = this.cleanValues.bind(this);
		this.searchFidelityByOffer = this.searchFidelityByOffer.bind(this);
	}

	componentDidMount() {
		const { receiveBanks, offer, isIframe } = this.props;
		const { form } = this.state;
		const token = getUserToken();
		const self = this;
		let acronym = this.props.acronym;
		let acronymStorage = localStorage.getItem("FidelityAcronym");

		if (acronymStorage) {
			acronym = acronymStorage;
			this.searchOffer = true;
			this.redirectOffer = acronymStorage;
			localStorage.removeItem("FidelityAcronym");
		}

		waitRequests = 0; // aparecer loading de steps

		if (acronym && !form.fidelity) {
			getFidelities(undefined, 1).then(response => {
				if (self._unmounted) return;
				self.searchFidelityByOffer(response.data, "1", acronym);
			});

			getFidelities(undefined, 2).then(response => {
				if (self._unmounted) return;
				self.searchFidelityByOffer(response.data, "2", acronym);
			});
		}

		if (offer) {
			form.fidelityId = offer.fidelity.id;
			if (offer.formFidelity) {
				form.fidelity = offer.formFidelity;
			}

			if (offer.showModalQuickSaleProblem) {
				form.showModalQuickSaleProblem = offer.showModalQuickSaleProblem;
			}

			if (offer.showModalForwardPaymentProblem) {
				form.showModalForwardPaymentProblem = offer.showModalForwardPaymentProblem;
			}

			if (offer.skipStep && !form.skipStep) {
				form.quantMiles = offer.quant;
				form.price = offer.price;
				form.skipStep = true;
				form.quickSale = true;
				this.setState({ form, currentStep: 2 });
			} else {
				this.setState({ form });
			}
		}

		//Checa se o usuário está logado e redireciona ou busca suas compras
		if (token && !isIframe) {
			const { data, loading } = this.props;

			if (!loading && !data) {
				this.props.refreshOffers();
			} else {
				this.setState({
					loading,
					allOffers: data && data.offers
				});
			}

			getBanks(token)
				.then(response => {
					if (self._unmounted) return;
					receiveBanks(response.data);
				})
				.catch(error => {
					console.log("Erro ao carregar bancos, token: " + token);
				});

			waitRequests = 2;

			hasBank(token)
				.then(response => {
					waitRequests--;
					if (self._unmounted) return;
					self.setState({ userHasBank: response.data.hasBankData });
				})
				.catch(res => {
					waitRequests--;
				});

			this.setState({ userHasCreditCard: true }); // OFW-444 Remover opção de cadastro de cartão de crédito no cadastro/edição da oferta
			waitRequests--;
			/*hasCreditCard(token)
				.then(response => {
					waitRequests--;
					if (self._unmounted) return;
					self.setState({ userHasCreditCard: response.data.hasCreditCard });
				})
				.catch(res => {
					waitRequests--;
				});*/
		}
	}

	componentWillReceiveProps(nextProps) {
		const { form } = this.state;
		const token = getUserToken();

		if (!token || this.state.currentStep == 5) {
			return;
		}

		const { data, loading, dataRelationshipParticipant } = nextProps;

		// Valida se é um usuário com gestor com vinculo pra ignorar dados bancários
		let hasManagementActive =
			this.state.hasManagementActive ||
			(dataRelationshipParticipant &&
				dataRelationshipParticipant.some(re => isRelationshipStatusActive(re)));

		// Vinculo pendente
		let hasRelationshipPendent =
			this.state.hasRelationshipPendent ||
			(!hasManagementActive && // Se tiver vinculo ativo não precisa validar
				dataRelationshipParticipant &&
				dataRelationshipParticipant.some(re => isRelationshipStatusPendentOrNegotiation(re)));

		this.setState({
			loading,
			allOffers: data && data.offers,
			hasManagementActive,
			hasRelationshipPendent
		});

		if (this.searchOffer && !loading && data && data.offers) {
			// Verifica se ele possui uma oferta disponivel pra editar, se sim manderemos ele pra tela de edição
			let found = data.offers.find(
				offer =>
					offer.fidelity.airlineAcronym == (form.fidelity && form.fidelity.label) ||
					offer.fidelity.airlineAcronym.toLowerCase() == this.redirectOffer
			);

			if (found) {
				if (found.status > 0) {
					found = Object.assign({}, found);

					// Quando estava deslogado e trocou o programa (platinum -> multiplus) pra ir pro editar setado
					if (form.fidelityId) {
						found.fidelity.id = form.fidelityId;
					}

					// Pra exibir no header do simulador os valores originais da oferta
					found.oldQuant = found.quant;
					found.oldPrice = found.price;

					// Quando redireciona não precisa atribuir os valores pq está sempre vazio
					if (!this.redirectOffer) {
						// Troca os valores da oferta pra exibir o que foi preenchido deslogado
						found.quant = form.quantMiles;
						found.price = form.price;
					}

					if (form.quickSale || form.forwardPayment) {
						found.skipStep = form.currentStep == 2;
						found.formFidelity = form.fidelity;
					}

					if (form.showModalQuickSaleProblem) {
						found.showModalQuickSaleProblem = form.showModalQuickSaleProblem;
					}

					if (form.showModalForwardPaymentProblem) {
						found.showModalForwardPaymentProblem = form.showModalForwardPaymentProblem;
					}

					// Manda pra tela de editar
					this.edit(found);
				} else {
					this.setState({
						form: {
							...form,
							fidelity: {
								...form.fidelity,
								offerId: found.id
							}
						}
					});
				}
				this.searchOffer = false;
			}
		}
	}

	componentWillMount() {
		if (getUserToken()) {
			this.props.getRelationshipsParticipant();
		}
	}

	edit(offer) {
		const { editOffer, history } = this.props;
		window.scrollTo(0, 0);
		// Não mostrar mais aviso
		localStorage.setItem("SimulatorMilesAviso", "1");
		editOffer(offer);
		history.push(ROUTE_PREFIX_EDIT_OFFER);
	}

	searchFidelityByOffer(airlines, locale, acronym) {
		if (this._unmounted) return;
		const { form } = this.state;
		const { offer } = this.props;

		let found = airlines.find(
			airline => airline.airlineAcronym.toLowerCase() == acronym.toLowerCase()
		);

		if (found) {
			let fidelity = found.fidelities.sort((a, b) =>
				a.name < b.name ? -1 : a.name > b.name ? 1 : 0
			)[0];

			if (offer) {
				fidelity = found.fidelities.find(f => f.id == offer.fidelity.id);
			}

			form.locale = locale;
			form.fidelity = {
				value: fidelity.id,
				label: found.airlineAcronym,
				highlight: fidelity.name,
				name: fidelity.name,
				link: fidelity.link,
				fidelities: found.fidelities,
				offerId: offer ? offer.id : undefined,
				valMinMiles: fidelity.valMinMiles
			};
			form.fidelityId = fidelity.id;
			this.setState({ form });
		}
	}

	componentWillUnmount() {
		this._unmounted = true;
		this.cleanValues();
	}

	//Salva cada dado informado, em cada passo, ao objeto principal
	saveValuesPerStep(stepValues) {
		let form = this.state.form;

		if (form.errors && stepValues.errors) {
			stepValues.errors = Object.assign({}, form.errors, stepValues.errors);
		}

		form = Object.assign({}, form, stepValues);
		this.setState({ form });
		return form;
	}

	cleanValues() {
		this.setState({
			currentStep: 1,
			fetchingOffers: false,
			form: {
				errors: {}
			}
		});
	}

	// Para avancar o step
	incStep(stepData) {
		const { isIframe } = this.props;
		const {
			userHasBank,
			userShowBankAndLogin,
			userHasCreditCard,
			hasManagementActive
		} = this.state;

		// Sempre remove o token quando tiver nessa tela
		if (isIframe) {
			logoutUser();
			localStorage.removeItem("au");
		}

		const token = getUserToken();
		let saved = this.saveValuesPerStep(stepData);

		// Não aparecer modal quando voltar
		delete saved.showAvisoConfirmar;

		let currentStep = this.state.currentStep;
		currentStep++;

		if (currentStep == 2 && !token) {
			currentStep = 0;

			if (isIframe) {
				currentStep = 1;
				let urlRedirect = ROUTE_REDIRECT_SIMULATOR.toString();
				let params =
					window.location.search ||
					"?utm_source=infomoney&utm_medium=publieditorial&utm_campaign=abr-2019_aumento-cartao-credito-impulsiona-mercado-de-milhas";

				if (stepData && stepData.fidelity) {
					urlRedirect = getCorrectUrlByAcronym(stepData.fidelity.label) + params;
				}

				window.open(urlRedirect);
			} else {
				window.history.pushState(ROUTE_REDIRECT_OFFER.toString(), document.title, ROUTE_REDIRECT_OFFER);
			}

			saved.logged = true;
			saved.referrer = document.location.href;
			localStorage.setItem("CreateOffer", JSON.stringify(saved));

			if (!isIframe) {
				redirectToLogin(window);
			}
		}

		if (currentStep == 3 && (hasManagementActive || userHasBank || userShowBankAndLogin)) {
			// dados bancários
			currentStep++;
		}

		if (currentStep == 4) {
			// cartão credito
			this.setState({ userHasBank: true });
			if (userHasCreditCard) {
				currentStep++;
			}
		}

		if (currentStep == 5) {
			// parabéns
			this.setState({ userHasCreditCard: true });
		}

		this.setState({
			currentStep,
			userShowBankAndLogin: window._mmTestBankAndLogin
		}); // _mmTestBankAndLogin -> OFW-474 - Colocar tela dos dados bancários junto com a tela de dados de fidelidade (teste a/b)
	}

	// Para voltar o step
	decStep(stepData) {
		const { token, userHasBank, userHasCreditCard } = this.state;
		let currentStep = this.state.currentStep;

		if (currentStep == 1 && this.props.showOffers) {
			// voltar da edição
			this.cleanValues();
			this.props.showOffers();
			return;
		}

		this.saveValuesPerStep(stepData);

		currentStep--;

		if (currentStep == 4 && userHasCreditCard) {
			// cartão credito
			currentStep--;
		}

		if (currentStep == 3 && userHasBank) {
			// dados bancários
			currentStep--;
		}

		this.setState({ currentStep });
	}

	renderStep() {
		const {
			currentStep,
			userShowBankAndLogin,
			userHasBank,
			allOffers,
			hasManagementActive,
			hasRelationshipPendent
		} = this.state;
		const { acronym, offer, dedicatedOffer, isIframe, edit } = this.props;

		let form = this.state.form;

		let fidelity = form.fidelity;

		window.scrollTo(0, 0);
		switch (currentStep) {
			case 0:
				return (
					<SimulatorMiles
						fidelity={acronym ? fidelity || { fidelities: [] } : undefined}
						selected={this.redirectOffer ? fidelity : undefined}
						form={form}
						edit={edit}
						dedicatedOffer={dedicatedOffer}
						isIframe={isIframe}
						offers={allOffers}
						offer={offer}
						prev={this.decStep}
						next={this.incStep}
						hasRelationshipPendent={hasRelationshipPendent}
						hasManagementActive={hasManagementActive}
					>
						<Modal
							title="CARREGANDO DADOS"
							description="Estamos checando seu usuário, aguarde... :)"
							show={true}
						/>
					</SimulatorMiles>
				);
			case 1:
				return (
					<SimulatorMiles
						fidelity={acronym ? fidelity || { fidelities: [] } : undefined}
						selected={this.redirectOffer ? fidelity : undefined}
						form={form}
						edit={edit}
						dedicatedOffer={dedicatedOffer}
						isIframe={isIframe}
						offers={allOffers}
						offer={offer}
						prev={() => (window.location.href = ROUTE_HOME)}
						next={this.incStep}
						hasRelationshipPendent={hasRelationshipPendent}
						hasManagementActive={hasManagementActive}
					/>
				);
			case 2:
				return userShowBankAndLogin && !userHasBank ? (
					<RegisterBankDetailsAndLogin
						fidelity={acronym ? fidelity || { fidelities: [] } : undefined}
						form={form}
						offers={allOffers}
						prev={this.decStep}
						next={this.incStep}
						hasRelationshipPendent={hasRelationshipPendent}
					/>
				) : (
					<LoginOffer
						fidelity={acronym ? fidelity || { fidelities: [] } : undefined}
						form={form}
						offers={allOffers}
						prev={this.decStep}
						next={this.incStep}
						hasRelationshipPendent={hasRelationshipPendent}
					/>
				);
			case 3:
				return <RegisterBankDetails form={form} prev={this.decStep} next={this.incStep} />;
			case 4:
				return <RegisterCreditCard form={form} prev={this.decStep} next={this.incStep} />;
			case 5:
				return (
					<FinishedOffer
						form={form}
						prev={this.decStep}
						next={this.incStep}
						offer={offer}
						cleanValues={this.cleanValues}
					/>
				);
			default:
				return <SimulatorMiles />;
		}
	}

	render() {
		const { loading, form, userHasBank, userShowBankAndLogin, userHasCreditCard } = this.state;
		const { offer, dedicatedOffer, loadingParticipant } = this.props;
		let currentStep = this.state.currentStep;

		let fidelity, quantMiles, price;
		let total = 4;

		if (currentStep > 1) {
			// Não exibir se for primeira tela
			fidelity = form.fidelity;
			quantMiles = form.quantMiles;
			price = form.price;
		} else if (offer) {
			// Edição da oferta
			fidelity = {
				name: offer.fidelity.name,
				label: offer.fidelity.airlineAcronym
			};
			quantMiles = offer.oldQuant || offer.quant;
			price = offer.oldPrice || offer.price;
		}
		if (userHasBank || userShowBankAndLogin) {
			total--;
		}
		if (userHasCreditCard) {
			total--;
		}

		if (currentStep > total) {
			currentStep = total;
		}

		const { acronym, edit } = this.props;

		if (loading || waitRequests > 0 || loadingParticipant) {
			return <Loading label="Buscando programas..." />;
		}

		return (
			<div
				className={`create-offer ${acronym && !edit ? "create-offer--acronym" : ""} ${dedicatedOffer ? "create-offer--dedicated" : ""
					}`}
			>
				<div className="create-offer--title row hidden-xs">
					<strong>{`${offer ? "Editar oferta" : "Cadastro de Oferta"}`}</strong>
					{fidelity && <span>{`${fidelity.name} • ${fidelity.label}`}</span>}
					{quantMiles ? (
						<span>
							<span className="create-offer--dot">•</span>
							<span>{`${intFormat(quantMiles)} milhas`}</span>
						</span>
					) : null}
					{price ? (
						<span>
							<span className="create-offer--dot">•</span>
							<span>{formatCurrency(price)}</span>
						</span>
					) : null}
					{this.state.currentStep != 5 && (
						<span className="create-offer--title-steps">
							{currentStep}
							<span>/{total}</span>
						</span>
					)}
				</div>
				<div className={`create-offer--content row`}>
					<StepBarIndicator currentStep={currentStep} total={total} />
					{currentStep !== 1 && (
						<div className="col-xs-16 create-offer--title no-margin row visible-xs">
							<div className="col-xs-16 text-center create-offer--title-mobile">
								{fidelity && <span>{fidelity.name}</span>}
								{quantMiles ? (
									<span>
										<i className="icon-arrow-down icon-to-left" />
										<span>{`${intFormat(quantMiles)} milhas`}</span>
									</span>
								) : null}
								{price ? (
									<span>
										<i className="icon-arrow-down icon-to-left" />
										<span>{formatCurrency(price)}</span>
									</span>
								) : null}
							</div>
						</div>
					)}
					{this.renderStep()}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	data: state.offers.data,
	loading: state.offers.loading,
	dataRelationshipParticipant: state.accountLink.dataRelationshipParticipant,
	loadingParticipant: state.accountLink.isLoading.getRelationshipsParticipant
});

const mapDispatchToProps = dispatch => {
	return {
		refreshOffers: () => dispatch(refreshOffers()),
		receiveBanks: banks => dispatch(receiveBanks(banks)),
		showOffers: () => dispatch(showOffers()),
		editOffer: offer => dispatch(editOffer(offer)),
		getRelationshipsParticipant: () => dispatch(getRelationshipsParticipant())
	};
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(CreateOffer)
);
